const initialState = {
  isLoading: false,
  totalRegistros: 0,
  categoriaProduto: [],
  id: 0,
  nome: '',
  excluido: false,
  loja: null,
  page: 0,
  limit: 10,
  order: 'nome',
  direction: 'asc',
  term: ''
}

export function categoriaProduto(state = initialState, action) {
  switch (action.type) {
    case 'FETCHED_ALL_CATEGORIAPRODUTO':
      return {
        ...state,
        categoriaProduto: action.categoriaProduto,
        totalRegistros: action.totalRegistros
      }
    case 'CATEGORIAPRODUTO_DETAIL':
      return {
        ...state,
        isLoading: false,
        id: action.categoriaProduto.id,
        nome: action.categoriaProduto.nome,
        excluido: action.categoriaProduto.excluido,
      }
    case 'CATEGORIAPRODUTO_UPDATED':
      return state
    case 'CATEGORIAPRODUTO_CLEAR':
      return {
        ...initialState,
        page: state.page,
        limit: state.limit,
        order: state.order,
        direction: state.direction,
        term: state.term,
      }
    case 'CATEGORIAPRODUTO_CLEAR_ALL':
      return {
        ...state,
        categoriaProduto: []
      }
    case 'CATEGORIAPRODUTO_HANDLE_ON_CHANGE':
      return {
        ...state,
        [action.props]: action.value
      }
    case 'CATEGORIAPRODUTO_ISLOADING':
      return {
        ...state,
        isLoading: true
      }
    case 'CATEGORIAPRODUTO_NOTISLOADING':
      return {
        ...state,
        isLoading: false
      }
    default:
      return state
  }
}
